import { useState } from 'react';
import { Box, CloseButton } from '@customerio/pluma-components/react';
import * as styles from './welcome-banner.css';

const DISMISSED_KEY = 'home:welcome-banner-dismissed';

export function WelcomeBanner() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISSED_KEY) === 'true');

  if (dismissed) {
    return null;
  }

  return (
    <Box w="full" position="relative">
      <CloseButton
        onClick={() => {
          localStorage.setItem(DISMISSED_KEY, 'true');
          setDismissed(true);
        }}
        className={styles.closeButton}
      />
      <div className={styles.card}>
        <div className={styles.imageArea}>
          <div className={styles.screenshotMock} />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>Welcome to the new Customer.io</div>
          <div className={styles.subtitle}>New home page, faster navigation, and your AI agent — all in one place.</div>
        </div>
      </div>
    </Box>
  );
}
